import styled from "styled-components";


export const TagComponent = styled.p`
  display: inline-block;
  border-radius: 5px;
  border-color: ${({ theme }) => theme.colors.primary};
  color: inherit;
  font-size:18px;
  background-color: #f9fafb;;
  padding: 4px 12px;
`;